// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b6981812","453":"733b9145","455":"0854b2ca","977":"684dfd1f"}[chunkId] + ".chunk.js";
};